var moduleMap = {
	"./HelloWorld.vue": () => {
		return Promise.all([__webpack_require__.e(20), __webpack_require__.e(367), __webpack_require__.e(918), __webpack_require__.e(679)]).then(() => (() => ((__webpack_require__(99217)))));
	},
	"./plugin": () => {
		return Promise.all([__webpack_require__.e(20), __webpack_require__.e(367), __webpack_require__.e(798), __webpack_require__.e(306), __webpack_require__.e(918), __webpack_require__.e(376), __webpack_require__.e(124), __webpack_require__.e(264)]).then(() => (() => ((__webpack_require__(66843)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(376), __webpack_require__.e(124), __webpack_require__.e(224)]).then(() => (() => ((__webpack_require__(65224)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});